export const insertPathBeforeUrlQuery = (baseUrl: string, path: string): string => {
  const pathSuffix = path.startsWith('/') ? path : `/${path}`;
  const queryStartIndex = baseUrl.indexOf('?');

  return queryStartIndex < 0
    ? `${baseUrl}${pathSuffix}`
    : `${baseUrl.slice(0, queryStartIndex)}${pathSuffix}${baseUrl.slice(queryStartIndex)}`;
};
